import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "loading",
    "keyModal",
    "saving",
    "notification",
    "message",
    "submit",
  ];

  connect() {
    this.hasUnsavedChanges = false;
  }

  detectChanges() {
    this.hasUnsavedChanges = true;
    this.submitTarget.disabled = false;
  }

  checkUnsavedChanges(event) {
    if (this.hasUnsavedChanges) {
      event.preventDefault();
      event.returnValue =
        "You have unsaved changes. Are you sure you want to leave?";
    }
  }

  async submit(event) {
    event.preventDefault();
    this.loadingTarget.classList.remove("hidden");
    this.savingTarget.classList.remove("hidden");

    try {
      const form = event.target;
      const response = await fetch(form.action, {
        method: form.method,
        body: new FormData(form),
        headers: {
          Accept: "text/vnd.turbo-stream.html",
        },
      });

      if (response.ok) {
        this.hasUnsavedChanges = false;
        this.showNotification("Settings saved successfully", "success");
      } else {
        this.showNotification("Failed to save settings", "error");
      }
    } catch (error) {
      this.showNotification("An error occurred", "error");
    } finally {
      this.loadingTarget.classList.add("hidden");
      this.savingTarget.classList.add("hidden");
    }
  }

  openKeyModal() {
    this.keyModalTarget.classList.remove("hidden");
  }

  closeKeyModal() {
    this.keyModalTarget.classList.add("hidden");
  }

  async generateKey(event) {
    event.preventDefault();
    const form = event.target;

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        headers: {
          Accept: "text/vnd.turbo-stream.html",
        },
      });

      if (response.ok) {
        this.closeKeyModal();
        this.showNotification("API key generated successfully", "success");
      } else {
        this.showNotification("Failed to generate API key", "error");
      }
    } catch (error) {
      this.showNotification("An error occurred", "error");
    }
  }

  confirmCancel(event) {
    if (this.hasUnsavedChanges) {
      if (
        !confirm("You have unsaved changes. Are you sure you want to leave?")
      ) {
        event.preventDefault();
      }
    }
  }

  showNotification(message, type) {
    this.messageTarget.textContent = message;
    const notification = this.notificationTarget;

    notification.classList.remove("hidden");
    notification.classList.add(
      type === "success"
        ? "bg-green-50 border-green-200 text-green-800"
        : "bg-red-50 border-red-200 text-red-800"
    );

    setTimeout(() => {
      notification.classList.add("hidden");
    }, 3000);
  }
}
